import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CommentsState {
  showSidebar: boolean;
  showSectionSidebar: boolean;
  clipId: string;
  clipName: string;
  sectionId: string;
  sectionName: string;
}

const initialState: CommentsState = {
  showSidebar: false,
  showSectionSidebar: false,
  clipId: '',
  clipName: '',
  sectionId: '',
  sectionName: '',
};

type CurrentClipPayload = {
  clipId: string;
  clipName: string;
};

type CurrentSectionPayload = {
  sectionId: string;
  sectionName: string;
};

const commentsSlice = createSlice({
  name: 'comments',
  initialState,
  reducers: {
    showSidebar: (state, action: PayloadAction<CurrentClipPayload>) => {
      const { clipId, clipName } = action.payload;

      if (!clipId || !clipName) return state;

      return {
        ...state,
        showSidebar: true,
        ...action.payload,
      };
    },
    showSectionSidebar: (
      state,
      action: PayloadAction<CurrentSectionPayload>
    ) => {
      const { sectionId, sectionName } = action.payload;

      if (!sectionId || !sectionName) return state;

      return {
        ...state,
        showSectionSidebar: true,
        ...action.payload,
      };
    },
    hideSidebar: state => {
      return {
        ...state,
        clipId: '',
        clipName: '',
        showSidebar: false,
      };
    },
    hideSectionSidebar: state => {
      return {
        ...state,
        clipId: '',
        clipName: '',
        showSectionSidebar: false,
      };
    },
    reset: () => initialState,
  },
});

export const {
  showSidebar: showCommentsSidebar,
  hideSidebar: hideCommentsSidebar,
  showSectionSidebar: showSectionCommentsSidebar,
  hideSectionSidebar: hideSectionCommentsSidebar,
  reset: resetCommentsSidebarState,
} = commentsSlice.actions;

export default commentsSlice;
